import type { Ref } from 'react';
import { useId } from 'react';

export interface SwitchProps {
  name?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  onBlur?: () => void;
  ref?: Ref<HTMLInputElement>;
}

export const Switch = ({ name, checked, onChange, onBlur, ref }: SwitchProps) => {
  const generatedId = useId();
  const inputId = name ? `switch-${name}` : generatedId;
  return (
    <label className='relative h-6 w-12' htmlFor={inputId}>
      <input
        type='checkbox'
        ref={ref}
        id={inputId}
        name={name}
        className='custom_switch peer absolute z-10 h-full w-full cursor-pointer opacity-0'
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onBlur={onBlur}
      />
      <span className='peer-checked:bg-c1 dark:bg-dark dark:before:bg-white-dark block h-full rounded-full bg-[#ebedf2] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-full before:bg-white before:transition-all before:duration-300 peer-checked:before:left-7 dark:peer-checked:before:bg-white' />
    </label>
  );
};
